// Wait Until
export const ENROLLED_OBJECT = 'ENROLLED_OBJECT';
export const PASSED_THROUGH_DATA = 'PASSED_THROUGH_DATA';
// Static Branch
export const OBJECT_PROPERTY = 'OBJECT_PROPERTY';
export const FIELD_DATA = 'FIELD_DATA';
export const FETCHED_OBJECT = 'FETCHED_OBJECT';